require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-veterans-in-tech-summit-a-recap-of-washingtons-inaugural-veteran-and-technology-event.json") })
        }
      }, "path---blog-veterans-in-tech-summit-a-recap-of-washingtons-inaugural-veteran-and-technology-event");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-veterans-in-tech-summit-a-recap-of-washingtons-inaugural-veteran-and-technology-event!./.cache/json/blog-veterans-in-tech-summit-a-recap-of-washingtons-inaugural-veteran-and-technology-event.json
// module id = 1115
// module chunks = 231608221292675